import { useState } from 'react';
import Box from '@mui/material/Box';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { HeatLeaderboard, HeatLeaderboardProps } from './HeatLeaderboard';
import {
  RefereeHeader,
  USEFUL_INFO_HEATS,
} from 'src/components/referee-portal/RefereeHeader';
import { useServerTime } from 'src/contexts/useServerTime';
import { useAuth } from 'src/contexts/AuthContext';
import { isAdmin } from 'functions/src/types/firestore/User/util';

export type HeatsLeaderboardsTabProps = Pick<
  HeatLeaderboardProps,
  'handleTabChange' | 'sponsors'
> & {
  heats: Omit<HeatLeaderboardProps, 'handleTabChange'>[];
};

export const HeatsLeaderboardsTab = ({
  heats,
  sponsors,
  handleTabChange,
}: HeatsLeaderboardsTabProps) => {
  const [selectedHeat, setSelectedHeat] = useState(0);
  const { userData } = useAuth();
  const isAuthenticated = isAdmin(userData?.email);
  const { now } = useServerTime();
  return (
    <>
      <Box sx={{ display: 'flex' }}>
        <ToggleButtonGroup
          value={selectedHeat}
          exclusive
          onChange={(_, value) => {
            if (value) {
              setSelectedHeat(value);
            }
          }}
          size="small"
          sx={{ width: '100%', m: 8, height: 40 }}
        >
          {heats?.map((heat, index) => {
            const hasStarted =
              heat?.startTime && heat?.startTime?.valueOf() < now();
            return (
              <ToggleButton
                value={index}
                disabled={!hasStarted}
                sx={{ width: '100%' }}
                key={heat.title}
                onClick={() => {
                  return setSelectedHeat(index);
                }}
              >
                {heat.title}
              </ToggleButton>
            );
          })}
        </ToggleButtonGroup>
      </Box>
      {!!isAuthenticated && <RefereeHeader info={USEFUL_INFO_HEATS} />}
      <HeatLeaderboard
        {...heats[Number(selectedHeat)]}
        sponsors={sponsors}
        handleTabChange={handleTabChange}
      />
    </>
  );
};
